// Generated by Melange

import * as Curry from "melange.js/curry.jsx";
import * as Fx from "../fx/fx.jsx";
import * as Stdlib from "melange/stdlib.jsx";
import * as Stdlib__Option from "melange/option.jsx";
import * as StoreFx__PlayerContext from "./playerContext.jsx";
import * as StoreFx__SaveCurrentTime from "./saveCurrentTime.jsx";

function make(currentTime) {
  return Fx.Monad_syntax.let$star(Fx.ask(undefined), (function (param) {
    const store = param.store;
    const state = store.getState();
    StoreFx__PlayerContext.skipping.contents = true;
    const currentTime$1 = Math.max(0.0, Math.min(Curry._1(currentTime, state.player.currentTime), (function (param) {
      return Stdlib__Option.value(param, Stdlib.infinity);
    })(state.player.duration)));
    if (currentTime$1 === StoreFx__PlayerContext.audio.currentTime) {
      return {
        TAG: /* Ok */ 0,
        _0: undefined
      };
    } else {
      return {
        TAG: /* Async */ 3,
        _0: (function (param) {
          StoreFx__PlayerContext.audio.currentTime = currentTime$1;
          store.setState(function (prevState) {
            const init = prevState.player;
            return {
              albums: prevState.albums,
              artists: prevState.artists,
              auth: prevState.auth,
              player: {
                buffered: init.buffered,
                currentSongId: init.currentSongId,
                currentTime: currentTime$1,
                duration: init.duration,
                muted: init.muted,
                paused: init.paused,
                queuedSongIds: init.queuedSongIds,
                replayGainOptions: init.replayGainOptions,
                volume: init.volume
              },
              songs: prevState.songs
            };
          });
          return Curry._1(StoreFx__SaveCurrentTime.now, store).then(function (param) {
            return Promise.resolve({
              TAG: /* Ok */ 0,
              _0: undefined
            });
          }).catch(function (param) {
            return Promise.resolve({
              TAG: /* Error */ 1,
              _0: undefined
            });
          });
        })
      };
    }
  }));
}

export {
  make,
}
/* StoreFx__PlayerContext Not a pure module */
